<template>
  <div class="advert">
    <div
      class="flex"
      :class="{
        'swiper-container-adv-wap': $store.state.isMobile,
        'swiper-container-adv-pc': !$store.state.isMobile,
      }"
    >
      <div class="swiper-wrapper flex">
        <div
          class="swiper-slide flex"
          style="
            transform: translate3d(0, 0, 0);
            overflow: hidden;
            width: 100%;
            height: calc(100% - 30px);
          "
          v-for="(adv, index) in advList"
          :key="index"
          @mouseenter="currentVideo = index"
          @click="currentVideo = index"
          :data-swiper-slide-adv-index="index"
        >
          <div class="slide flex flex-direction cs">
            <div class="top-video">
              <img class="top-video_videoImg" :src="adv.coverImageUrl_new" />
            </div>
          </div>
        </div>
      </div>
      <!--     小圆点分页器       -->
      <div
        class="swiper-pagination-video-wap flex align-center justify-center"
        slot="pagination"
        style="width: 100%; height: 20px"
      ></div>
    </div>
  </div>
</template>

<script>
import { Swiper } from "vue-awesome-swiper";
import { staticApi } from "../services";
var self;
export default {
  name: "Advert",
  data() {
    return {
      currentVideo: 0,
      swiper_video_wap: null,
      swiper_video_pc: null,
      advList: [],
    };
  },
  created() {
    self = this;
    this.getAdvList();
  },
  methods: {
    //获取广告列表
    getAdvList() {
      staticApi
        .request(
          `/${this.$config.tenantId}/seminar/${this.$config.seminarId}/article/list/${this.$config.advListId}.json`
        )
        .then((res) => {
          if (res.result === 0) {
            const advList = res.content.items;
            advList.forEach((item) => {
              item.coverImageUrl_new = "";
              if (item.coverImageRealPath) {
                item.coverImageUrl_new = item.coverImageRealPath.replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
            });

            //位置排序
            advList.sort((a, b) => {
              return b.order - a.order;
            });
            this.advList = advList;
            this.$nextTick(() => {
              // 初始化swiper
              this.loadSwiper();
              this.$bus.$emit("ready", "advert");
            });
          }
        })
        .catch((err) => {
          console.error("获取列表失败", err);
        });
    },
    loadSwiper() {
      if (this.$store.state.isMobile) {
        this.swiper_video_wap = new Swiper(".swiper-container-adv-wap", {
          loop: true, //首尾循环
          autoplay: {
            delay: 3000, //1秒切换一次
          }, //等同于以下设置
          // centeredSlides: false,
          // loopedSlides: 10,
          // slidesPerView: 1.19, //每组 有多少块
          // spaceBetween: 15, //板块间隔
          // slidesPerGroup: 1, //多少个板块为1组。
          slidesPerView: "auto",
          centeredSlides: true,
          pagination: {
            el: ".swiper-pagination-video-wap",
            clickable: true,
            bulletClass: "my-bullet",
            bulletActiveClass: "my-bullet-active2",
          },
          on: {
            click(e) {
              const realIndex = this.realIndex;
              window._hw("send", "action", "index_advertising_module_click", {
                content_name: self.advList[realIndex].title,
              });
              window.open(self.advList[realIndex].summary); // 新窗口打开外链接
            },
          },
        });
      } else {
        this.swiper_video_pc = new Swiper(".swiper-container-adv-pc", {
          loop: true, //首尾循环
          autoplay: {
            delay: 3000, //1秒切换一次
          }, //等同于以下设置
          slidesPerView: 3, //每组 有多少块
          centeredSlides: false,
          spaceBetween: 10, //板块间隔
          slidesPerGroup: 3, //多少个板块为1组。
          pagination: {
            el: ".swiper-pagination-video-wap",
            clickable: true,
            bulletClass: "my-bullet",
            bulletActiveClass: "my-bullet-active2",
          },
          on: {
            click(e) {
              const realIndex = this.clickedSlide.getAttribute(
                "data-swiper-slide-adv-index"
              );
              window._hw("send", "action", "index_advertising_module_click", {
                content_name: self.advList[realIndex].title,
              });
              window.open(self.advList[realIndex].summary); // 新窗口打开外链接
            },
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 992px) {
  .advert {
    display: block;
    width: 100%;
    padding-top: 143px;
    ::v-deep .swiper-container-adv-wap {
      position: relative;
      width: 100%;
      height: 300px;
      .swiper-slide {
        width: 80% !important;
        margin: 0 2%;
      }
      .swiper-slide-active {
        transition: 200ms;
        transform: scale(1) !important;
      }
      .swiper-slide-prev {
        right: 1%;
        transition: 200ms;
        //transform: scale(0.9) !important;
      }
      .swiper-slide-next {
        left: 1%;
        transition: 200ms;
        //transform: scale(0.9) !important;
      }
      .swiper-pagination-video-wap {
        position: absolute;
        bottom: 0px;
        left: 0;
        z-index: 10;
      }
      .my-bullet {
        width: 26px;
        height: 8px;
        background: #c4c4c4;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin: 0 5px;
      }
      .my-bullet-active2 {
        background: #b4251e;
      }
    }
    .slide {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      position: relative;
      transform: translate3d(0, 0, 0);
      .top-video {
        width: 100%;
        height: 320px;
        position: relative;
        .top-video_videoImg {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 10px;
        }
      }
    }
  }
}
@media screen and (min-width: 992px) {
  .advert {
    display: block;
    width: 1920px;
    height: 343px;
    padding-top: 60px;
    padding-bottom: 60px;
    ::v-deep .swiper-container-adv-pc {
      position: relative;
      width: 1600px;
      height: 270px;
      margin-left: 160px;
      overflow-x: hidden;
      .swiper-slide {
        //width: 523.3px !important;
      }
      .swiper-pagination-video-wap {
        position: absolute;
        bottom: 0px;
        left: 0;
        z-index: 10;
      }
      .my-bullet {
        width: 26px;
        height: 4px;
        background: #c4c4c4;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin: 0 5px;
      }
      .my-bullet-active2 {
        background: #b4251e;
      }
    }
    .slide {
      width: 100%;
      height: 80%;
      box-sizing: border-box;
      position: relative;
      transform: translate3d(0, 0, 0);
      .top-video {
        width: 100%;
        height: 320px;
        position: relative;
        .top-video_videoImg {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
